import React from 'react'
import queryString from 'query-string'
import { APP_NAME } from '../../brand'

class ResetPassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      password: '',
      confirm: '',
      error: '',
      success: false,
      loading: false
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  async handleSubmit(e) {
    e.preventDefault()
    const { password, confirm } = this.state
    if (!password || password.length < 6) {
      return this.setState({ error: 'Password must be at least 6 characters.' })
    }
    if (password !== confirm) {
      return this.setState({ error: 'Passwords do not match.' })
    }

    const params = queryString.parse(this.props.location.search)
    if (!params.token) {
      return this.setState({ error: 'Invalid link.' })
    }

    this.setState({ loading: true, error: '' })
    try {
      const res = await fetch('/endpoint/auth/email/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: params.token, password })
      })
      const data = await res.json()
      if (data.status === 'success') {
        this.setState({ success: true, loading: false })
      } else {
        this.setState({ error: data.message || 'Something went wrong.', loading: false })
      }
    } catch (err) {
      this.setState({ error: 'Connection error — try again.', loading: false })
    }
  }

  render() {
    const { password, confirm, error, success, loading } = this.state

    return (
      <div className="ng-container" style={{ maxWidth: 440, padding: '60px 20px' }}>
        <div className="ng-panel" style={{ textAlign: 'center' }}>
          <div className="ng-wordmark" style={{ justifyContent: 'center', marginBottom: 20 }}>
            <span className="ng-wordmark-key">⌂</span>
            <span>{APP_NAME}</span>
          </div>

          {success ? (
            <div>
              <span className="fa fa-check-circle" style={{ fontSize: 48, color: '#10b981', display: 'block', marginBottom: 16 }}></span>
              <h2 style={{ fontWeight: 800, marginBottom: 8 }}>Password changed</h2>
              <p style={{ color: '#64748b', marginBottom: 20 }}>You can now sign in with your new password.</p>
              <button className="ng-btn ng-btn-primary" onClick={() => this.props.history.push('/')}>
                Go to home page
              </button>
            </div>
          ) : (
            <form onSubmit={this.handleSubmit}>
              <h2 style={{ fontWeight: 800, marginBottom: 20 }}>Reset your password</h2>

              <div className="ng-field">
                <label>New password</label>
                <input className="ng-input" type="password"
                  placeholder="At least 6 characters" value={password}
                  onChange={e => this.setState({ password: e.target.value })} />
              </div>

              <div className="ng-field">
                <label>Confirm password</label>
                <input className="ng-input" type="password"
                  placeholder="Repeat the password" value={confirm}
                  onChange={e => this.setState({ confirm: e.target.value })} />
              </div>

              {error ? <div className="ng-error" style={{ marginBottom: 12 }}>{error}</div> : null}

              <button type="submit" className="ng-btn ng-btn-primary ng-btn-block" disabled={loading}>
                {loading ? 'Updating…' : 'Set new password'}
              </button>
            </form>
          )}
        </div>
      </div>
    )
  }
}

export default ResetPassword
